module.exports = "<canvas class=\"qrCode\" #qrcodeElement></canvas>\n"